// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*::ng-deep .mat-dialog-container {
    padding: 0 !important;
}*/
.kanban-board{
    width: 45% !important;
}
/* .container-role {
    border-radius: 5px;
    margin-bottom: 1.25rem;
    background-color: #f7f8fa;
    max-height: 230px;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 50px;
} */

/* .security-title {
    padding: 15px;
    font-weight: 600;
    font-size: 1.2rem;
    color: #646cb4;
} */
.drag-role {
    border-radius: 4px;
    font-weight: 500;
    box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.05);
    background: #fff;
    padding: 10px;
    margin-bottom: 20px;
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    margin: 2px;
}

.dragged-role {
    min-height: 100px;
}

.drag-over {
    border: #ff525b dashed 2px;
}
.drag-hint {
    border: #ffc100 dashed 2px;
}
.drag-target-border {
    border: #5ae500 dashed 2px;
    height: 100%;
}
/* 
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background: #c5c5c5;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
} */
.theme-scroll{
    height: 40vh !important;
  }



  .kt-portlet__body{
    max-height: 70vh;
    overflow-y: auto;
}



.cdk-drag-preview {
  z-index: 1051 !important; /* higher than Bootstrap modal (z-index 1050) */
  pointer-events: none;
}

`, "",{"version":3,"sources":["webpack://./src/app/views/roles-dialoge/roles-dialoge.component.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,qBAAqB;AACzB;AACA;;;;;;;;GAQG;;AAEH;;;;;GAKG;AACH;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,YAAY;AAChB;AACA;;;;;;;;;;;;GAYG;AACH;IACI,uBAAuB;EACzB;;;;EAIA;IACE,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA;EACE,wBAAwB,EAAE,+CAA+C;EACzE,oBAAoB;AACtB","sourcesContent":["/*::ng-deep .mat-dialog-container {\r\n    padding: 0 !important;\r\n}*/\r\n.kanban-board{\r\n    width: 45% !important;\r\n}\r\n/* .container-role {\r\n    border-radius: 5px;\r\n    margin-bottom: 1.25rem;\r\n    background-color: #f7f8fa;\r\n    max-height: 230px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    min-height: 50px;\r\n} */\r\n\r\n/* .security-title {\r\n    padding: 15px;\r\n    font-weight: 600;\r\n    font-size: 1.2rem;\r\n    color: #646cb4;\r\n} */\r\n.drag-role {\r\n    border-radius: 4px;\r\n    font-weight: 500;\r\n    box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.05);\r\n    background: #fff;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);\r\n    margin: 2px;\r\n}\r\n\r\n.dragged-role {\r\n    min-height: 100px;\r\n}\r\n\r\n.drag-over {\r\n    border: #ff525b dashed 2px;\r\n}\r\n.drag-hint {\r\n    border: #ffc100 dashed 2px;\r\n}\r\n.drag-target-border {\r\n    border: #5ae500 dashed 2px;\r\n    height: 100%;\r\n}\r\n/* \r\n::-webkit-scrollbar {\r\n    width: 8px;\r\n    height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: #c5c5c5;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n} */\r\n.theme-scroll{\r\n    height: 40vh !important;\r\n  }\r\n\r\n\r\n\r\n  .kt-portlet__body{\r\n    max-height: 70vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n\r\n\r\n.cdk-drag-preview {\r\n  z-index: 1051 !important; /* higher than Bootstrap modal (z-index 1050) */\r\n  pointer-events: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
